export default __webpack_public_path__ + "static/media/game_port.29dd3c19.svg";